import {Component, h} from 'preact';
import ChatFrame from './chat-frame';
import ChatFloatingButton from './chat-floating-button';
import ChatTitleMsg from './chat-title-msg';
import ArrowIcon from './arrow-icon';
import Api from './api';
import {
    desktopClosedWrapperStyleChat,
    desktopTitleStyle,
    desktopWrapperStyle,
    mobileClosedWrapperStyle,
    mobileOpenWrapperStyle, mobileTitleStyle
} from './style';
import {IConfiguration} from '../typings';
import SpeechBubble from "./speech-bubble";

export default class Widget extends Component<any, IWidgetState> {


    declare state: IWidgetState;

    constructor() {
        super();
        this.state.isChatOpen = false;
        this.state.pristine = true;
        this.state.wasChatOpened = false;
    }

    componentDidMount() {
        window.botmanChatWidget = new Api(this);


        if (typeof this.props.conf.init === 'function') {
            this.props.conf.init(window.botmanChatWidget);
        }
    }


    render(props: IWidgetProps, state: IWidgetState) {

        const {conf, isMobile} = props;
        const {isChatOpen, pristine} = state;
        const wrapperWidth = {width: isMobile ? conf.mobileWidth : conf.desktopWidth};
        // const desktopHeight = (window.innerHeight - 100 < conf.desktopHeight) ? window.innerHeight - 90 : conf.desktopHeight;
        const desktopHeight = 'calc(100% - 132px)';
        // conf.wrapperHeight = desktopHeight;

        let wrapperStyle, titleStyle,headerPadding;
        if (!isChatOpen && (isMobile || conf.alwaysUseFloatingButton)) {
            wrapperStyle = {...mobileClosedWrapperStyle}; // closed mobile floating button
        } else if (!isMobile) {
            wrapperStyle = (isChatOpen || this.state.wasChatOpened) ?
                (isChatOpen) ?
                    {...desktopWrapperStyle, ...wrapperWidth} // desktop mode, button style
                    :
                    {...desktopClosedWrapperStyleChat}
                :
                {...desktopClosedWrapperStyleChat}; // desktop mode, chat style
            titleStyle = desktopTitleStyle;
            headerPadding = '40px 0px 0px 25px';
        } else {
            wrapperStyle = mobileOpenWrapperStyle; // open mobile wrapper should have no border
            titleStyle = mobileTitleStyle;
            headerPadding = '10px 0px 0px 25px';
        }


        return (

            <div style={wrapperStyle}>

                {/* Open/close button */}
                {(isMobile || conf.alwaysUseFloatingButton) && !isChatOpen ?

                    <ChatFloatingButton onClick={this.toggle} conf={conf}/>

                    :

                    (isChatOpen || this.state.wasChatOpened) ?
                        (isChatOpen ?
                            <div style={{background: conf.themeSettings.mainColor, ...titleStyle}}
                                 onClick={this.toggle}>
                                <div style={{
                                    display: 'flex', alignItems: 'center', padding: headerPadding,
                                    fontSize: '15px', fontWeight: 'normal', color: conf.themeSettings.headerTextColor
                                }}>
                                    <img src={conf.themeSettings.iconTitle} style={{
                                        width: isMobile ? "40px" : "50px",
                                        borderRadius: "40px",
                                        boxSizing: "initial",
                                        marginRight: "10px",
                                        border: "7px solid rgba(255, 255, 255, 0.15)"
                                    }}/>
                                    <div style="line-height: 20px;">
                                        <div
                                            style="font-weight: bold; white-space: nowrap;font-size:24px; line-height:30px">{conf.title}</div>
                                        <small style="white-space: nowrap;">{conf.subTitle}</small>
                                    </div>
                                </div>
                                <ArrowIcon isOpened={isChatOpen} strokeColor={conf.themeSettings.headerTextColor}/>
                            </div> : <ChatTitleMsg onClick={this.toggle} conf={conf}/>)
                        :
                        <ChatTitleMsg onClick={this.toggle} conf={conf}/>
                }

                {/*Chat IFrame*/}
                <div key='chatframe' style={{
                    position:'relative',
                    display: isChatOpen ? 'block' : 'none',
                    height: isMobile ? conf.mobileHeight : desktopHeight
                }}>
                    {pristine ? null : <ChatFrame {...this.props} />}
                </div>
                {!isChatOpen && <SpeechBubble onClick={this.toggle} conf={conf}/>}

            </div>
        );
    }

    toggle = () => {
        let stateData = {
            pristine: false,
            isChatOpen: !this.state.isChatOpen,
            wasChatOpened: this.state.wasChatOpened
        };
        if (!this.state.isChatOpen && !this.state.wasChatOpened) {
            stateData.wasChatOpened = true;
        }
        this.setState(stateData);
        SpeechBubble.suppressSpeechBubbleWithCookie()
    };

    open() {
        this.setState({
            pristine: false,
            isChatOpen: true,
            wasChatOpened: true
        });
        SpeechBubble.suppressSpeechBubbleWithCookie()
    }

    close() {
        this.setState({
            wasChatOpened: true,
            pristine: false,
            isChatOpen: false
        });
    }
}

interface IWidgetState {
    isChatOpen: boolean,
    pristine: boolean,
    wasChatOpened: boolean,
}


interface IWidgetProps {
    iFrameSrc: string,
    conf: IConfiguration,
    isMobile: boolean,
}

declare global {
    interface Window {
        attachEvent: Function,
        botmanChatWidget: Api,
        Pusher: any,
        Echo: any
    }
}

// FIXME: toGMTString is deprecated
interface IDate extends Date {
    toUTCString(): string;
}
